import createEnum from 'scripts/lib/create_enum';

const AttachmentStatus = createEnum('AVAILABLE', 'ERROR');

export default AttachmentStatus;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/attachment/attachment_status.js